export default __webpack_public_path__ + "static/media/tick.4bbe7125.svg";